import { Channel as BaseChannel } from '@food/channel';
var Channel = BaseChannel;
export { Channel };
